import { Component, OnInit } from '@angular/core';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ProdutoList } from '../../models/produto-list.model';
import { CadastroProdutoService } from '../../services/cadastro-produto.service';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { formatDate } from 'ngx-bootstrap/chronos';
import { AtualizacoesAudit } from '../../models/atualizacoes-audit';
import { ProjetoPermission } from '../../models/projeto-permission.model';
import { NavigationService } from '../../services/navigation.service';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';

@Component({
  selector: 'app-detalhe-cadastro-produto-edit',
  templateUrl: './detalhe-cadastro-produto-edit.component.html',
  styleUrls: ['./detalhe-cadastro-produto-edit.component.scss']
})
export class DetalheCadastroProdutoEditComponent extends BaseFormComponent<ProdutoList> implements OnInit {

  actionLabel: string = 'Novo';
  idProjeto: number;
  bsValue = new Date();
  audit: AtualizacoesAudit;
  infoProjeto: any;
  permissions: ProjetoPermission;
  aba: any;

  constructor(
    private myService: CadastroProdutoService,
    public activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private navigation: NavigationService
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.loaded();
    this.initForm();
    // if( !this.permissions.edit_actived ){
    //   this.msgError("Acesso negado.","Erro na Solicitação");
    //   this.navigation.replace([`projetos/projeto/${this.idProjeto}/cadastro`]);
    // }
  }

  initForm() {
    this.form = this.fb.group({
      id: [''],
      description: ['', Validators.maxLength(250)],
      ds_goal: ['', Validators.maxLength(250)],
      value: ['0', [Validators.required, Validators.maxLength(10)]],
      date_start: [''],
      date_conclusion: [''],
    });

    if (this.entity) {
      this.audit = {
        prod_id: this.entity.id
      };

      this.actionLabel = 'Editar';

      this.form.patchValue(this.entity);
      this.form.patchValue({
        value: this.entity.value ?? '0',
        date_start: this.formatarData(this.entity.dt_start),
        date_conclusion: this.formatarData(this.entity.dt_conclusion),
      });
    }
  }

  formatarData(dataString: string): string {
    // Divide a string da data em ano, mês e dia
    if(dataString == null) return "";
    const [ano, mes, dia] = dataString.split('-');
    let dataFormatada = dataString;

    if (ano && mes && dia) {
      // Cria uma nova string de data no formato 'DD/MM/YYYY'
      dataFormatada = `${dia}/${mes}/${ano}`;
    }

    return dataFormatada;
  }

  voltar() {
    this.navigation.back([`projetos/projeto/${this.idProjeto}/produto`]);
  }

  getDataCreate(): ProdutoList {
    let data: ProdutoList;
    data = Object.assign({}, data, this.form.value);
    data.pf_id = this.idProjeto;
    if( data.value != '0' ) data.value = data.value.toString().replace(',', '.');

    data.dt_start = formatDate(data.date_start, 'DD/MM/YYYY');
    data.dt_conclusion = formatDate(data.date_conclusion, 'DD/MM/YYYY');
    if (data.dt_start == 'Invalid date') {
      data.dt_start = data.date_start;
    }
    if (data.dt_conclusion == 'Invalid date') {
      data.dt_conclusion = data.date_conclusion;
    }
    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();

      if (this.entity?.id) {
        this.addSub(
          this.myService.update(this.getDataCreate(), this.entity?.id).subscribe({
            next: (res: ProdutoList) => {
              this.msgSuccess('Cadastro alterado com sucesso!');
              EventSharedService.get('auditRefresh').emit();
              this.loaded();
            },
            error: (error) => {
              this.loaded();
            },
          })
        );
      } else {
        this.addSub(
          this.myService.create(this.getDataCreate()).subscribe({
            next: (res: ProdutoList) => {
              this.confirmation().subscribe(() => {
                this.navigation.replace(['projetos', 'projeto', this.idProjeto, 'produto', res?.id]);
              })
              this.loaded();
            },
            error: (error) => {
              this.loaded();
            },
          })
        );
      }
    }
    else {
      this.markAsDirty();
    }
  }

  confirmExcluir() {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  excluir(): void {
    this.loading();
    this.myService.delete(this.entity?.id).subscribe({
      next: (res) => {
        this.confirmation('Deletado com sucesso').subscribe(() => {
          this.navigation.replace([`projetos/projeto/${this.idProjeto}/produto`]);
        })
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error)
      }
    });
  }
}
